import { createContext } from 'react';
import { DEFAULT_CONTACT_CONTEXT } from './constants/defaultContext';

export const ContactContext = createContext(DEFAULT_CONTACT_CONTEXT);
